import { useCallback } from "react";
import { useGetRequest } from "../ApiWrappers/useGetRequest";
import { Config } from "src/Utils/ConfigService/LoadConfig";
import { v1 } from "src/Utils/ApiVersions";

interface IEditPayment {
    paymentMethodUpdateUrl: string;
}

export const useEditPaymentMethod = () => {
    const scope = Config.GetConfigData().auraLicensingService?.scopes[0];
    const baseUrl = Config.GetConfigData().auraLicensingService?.serviceUrl;
    const [getDetails, data, loading, error] = useGetRequest<IEditPayment>();

    const getEditPaymentInfo = useCallback((clinicId: string) => {
        if (clinicId) {
            const requestUrl = `${baseUrl}api/${v1}/payment/clinic/${clinicId}/update`;
            getDetails(scope, requestUrl);
        }
    }, [getDetails, scope, baseUrl]);

    return {
        getEditPaymentInfo,
        data,
        loading,
        error
    };
};